import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "status-panel"
};
const _hoisted_2 = {
  class: "overview-cards"
};
const _hoisted_3 = {
  class: "card-icon"
};
const _hoisted_4 = {
  class: "card-content"
};
const _hoisted_5 = {
  class: "card-title"
};
const _hoisted_6 = {
  class: "card-value"
};
const _hoisted_7 = {
  class: "card-subtitle"
};
const _hoisted_8 = {
  class: "overview-card index-status"
};
const _hoisted_9 = {
  class: "card-icon"
};
const _hoisted_10 = {
  class: "card-content"
};
const _hoisted_11 = {
  class: "card-title"
};
const _hoisted_12 = {
  class: "card-value"
};
const _hoisted_13 = {
  class: "card-subtitle"
};
const _hoisted_14 = {
  class: "card-icon"
};
const _hoisted_15 = {
  class: "card-content"
};
const _hoisted_16 = {
  class: "card-title"
};
const _hoisted_17 = {
  class: "card-value"
};
const _hoisted_18 = {
  class: "card-subtitle"
};
const _hoisted_19 = {
  class: "charts-section"
};
const _hoisted_20 = {
  class: "chart-card trend-chart-card"
};
const _hoisted_21 = {
  class: "chart-header trend-chart-header"
};
const _hoisted_22 = {
  class: "chart-title"
};
const _hoisted_23 = {
  class: "trend-controls"
};
const _hoisted_24 = {
  class: "trend-date-panel"
};
const _hoisted_25 = {
  class: "chart-content trend-chart-content"
};
const _hoisted_26 = {
  key: 0,
  class: "empty-state trend-empty-state"
};
const _hoisted_27 = {
  key: 1,
  class: "line-chart-wrapper"
};
const _hoisted_28 = {
  class: "chart-card"
};
const _hoisted_29 = {
  class: "chart-header"
};
const _hoisted_30 = {
  class: "chart-content"
};
const _hoisted_31 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_32 = {
  key: 1,
  class: "pie-chart-container"
};
const _hoisted_33 = {
  class: "pie-chart-wrapper"
};
const _hoisted_34 = {
  class: "chart-center-text"
};
const _hoisted_35 = {
  class: "center-value"
};
const _hoisted_36 = {
  class: "center-label"
};
const _hoisted_37 = {
  class: "chart-legend"
};
const _hoisted_38 = {
  class: "legend-label"
};
const _hoisted_39 = {
  class: "legend-value"
};
const _hoisted_40 = {
  class: "legend-percent"
};
const _hoisted_41 = {
  class: "chart-card"
};
const _hoisted_42 = {
  class: "chart-header"
};
const _hoisted_43 = {
  class: "chart-content"
};
const _hoisted_44 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_45 = {
  key: 1,
  class: "pie-chart-container"
};
const _hoisted_46 = {
  class: "pie-chart-wrapper"
};
const _hoisted_47 = {
  class: "chart-center-text"
};
const _hoisted_48 = {
  class: "center-value"
};
const _hoisted_49 = {
  class: "center-label"
};
const _hoisted_50 = {
  class: "chart-legend"
};
const _hoisted_51 = {
  class: "legend-label"
};
const _hoisted_52 = {
  class: "legend-value"
};
const _hoisted_53 = {
  class: "legend-percent"
};
const _hoisted_54 = {
  class: "actions-section"
};
const _hoisted_55 = {
  class: "action-card"
};
const _hoisted_56 = {
  class: "action-header"
};
const _hoisted_57 = {
  class: "action-content"
};
const _hoisted_58 = {
  key: 0,
  class: "progress-container"
};
const _hoisted_59 = {
  class: "progress-header"
};
const _hoisted_60 = {
  class: "progress-phase"
};
const _hoisted_61 = {
  class: "progress-percentage"
};
const _hoisted_62 = {
  class: "progress-details"
};
const _hoisted_63 = {
  key: 0,
  class: "progress-count"
};
const _hoisted_64 = {
  key: 1,
  class: "progress-time"
};
const _hoisted_65 = {
  key: 0,
  class: "progress-message"
};
const _hoisted_66 = {
  key: 1,
  class: "error-container"
};
const _hoisted_67 = {
  class: "error-icon"
};
const _hoisted_68 = {
  class: "error-content"
};
const _hoisted_69 = {
  class: "error-message"
};
const _hoisted_70 = {
  key: 0,
  class: "error-suggestion"
};
const _hoisted_71 = {
  class: "error-actions"
};
const _hoisted_72 = {
  key: 2,
  class: "action-buttons"
};
const _hoisted_73 = {
  class: "restore-section"
};
const _hoisted_74 = {
  key: 0,
  class: "file-info-section"
};
const _hoisted_75 = ["src"];
const _hoisted_76 = {
  key: 2,
  class: "card-bg-fallback"
};
const _hoisted_77 = {
  class: "file-card-header"
};
const _hoisted_78 = {
  class: "info-card-footer"
};
const _hoisted_79 = {
  class: "file-name"
};
const _hoisted_80 = {
  class: "file-meta"
};
const _hoisted_81 = ["src"];
const _hoisted_82 = {
  key: 2,
  class: "card-bg-fallback"
};
const _hoisted_83 = {
  class: "file-card-header warning"
};
const _hoisted_84 = {
  class: "info-card-footer"
};
const _hoisted_85 = {
  class: "file-name"
};
const _hoisted_86 = {
  class: "file-meta"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_DateRangeCalendar = _resolveComponent("DateRangeCalendar");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_Line = _resolveComponent("Line");
  const _component_Doughnut = _resolveComponent("Doughnut");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_image = _resolveComponent("el-image");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "overview-card total-files",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.fetchIndexInfo && $options.fetchIndexInfo(...args))
  }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_font_awesome_icon, {
    icon: "database"
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('sysStatus.totalFiles')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($data.indexInfo.totalFiles?.toLocaleString() || '0'), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('sysStatus.clickToRefresh')), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_font_awesome_icon, {
    icon: "clock"
  })]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('sysStatus.indexUpdateTime')), 1), _createElementVNode("div", _hoisted_12, _toDisplayString($options.formatTime($data.indexInfo.lastUpdated)), 1), _createElementVNode("div", _hoisted_13, _toDisplayString($options.getTimeAgo($data.indexInfo.lastUpdated)), 1)])]), _createElementVNode("div", {
    class: "overview-card system-version",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.openReleases && $options.openReleases(...args))
  }, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_font_awesome_icon, {
    icon: "code-branch"
  })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('sysStatus.systemVersion')), 1), _createElementVNode("div", _hoisted_17, "v" + _toDisplayString($data.version), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('sysStatus.clickToViewChangelog')), 1)])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_font_awesome_icon, {
    icon: "chart-line"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.uploadTrend')), 1), _createVNode(_component_el_button, {
    class: "trend-calendar-btn",
    circle: "",
    "aria-label": _ctx.$t('sysStatus.selectDateRange'),
    onClick: $options.openTrendDateDialog
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "calendar"
    })]),
    _: 1
  }, 8, ["aria-label", "onClick"])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_radio_group, {
    modelValue: $data.trendGroupBy,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.trendGroupBy = $event),
    size: "small",
    class: "trend-group-switch",
    "aria-label": _ctx.$t('sysStatus.uploadTrendGroupBy')
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio_button, {
      label: "channel"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysStatus.byChannelType')), 1)]),
      _: 1
    }), _createVNode(_component_el_radio_button, {
      label: "channelName"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysStatus.byChannelName')), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "aria-label"])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.trendDatePickerVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.trendDatePickerVisible = $event),
    title: _ctx.$t('sysStatus.selectDateRange'),
    width: $options.trendDateDialogWidth,
    class: "trend-date-dialog",
    "align-center": "",
    "append-to-body": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_DateRangeCalendar, {
      modelValue: $data.trendDateRange,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.trendDateRange = $event),
      onChange: $options.handleTrendDateRangeChange
    }, null, 8, ["modelValue", "onChange"])])]),
    _: 1
  }, 8, ["modelValue", "title", "width"]), _createElementVNode("div", _hoisted_25, [!$options.hasTrendData ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_font_awesome_icon, {
    icon: "inbox"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.noData')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_Line, {
    data: $options.uploadTrendChartData,
    options: $options.lineChartOptions
  }, null, 8, ["data", "options"])]))])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_font_awesome_icon, {
    icon: "share-alt"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.channelDistribution')), 1)]), _createElementVNode("div", _hoisted_30, [Object.keys($data.indexInfo.channelStats || {}).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_font_awesome_icon, {
    icon: "inbox"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.noData')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_Doughnut, {
    data: $options.channelChartData,
    options: $options.chartOptions
  }, null, 8, ["data", "options"]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString($data.indexInfo.totalFiles?.toLocaleString() || '0'), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('sysStatus.totalFilesLabel')), 1)])]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.indexInfo.channelStats, (count, channel, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: channel,
      class: "legend-item"
    }, [_createElementVNode("span", {
      class: "legend-color",
      style: _normalizeStyle({
        background: $options.getChartColor(index)
      })
    }, null, 4), _createElementVNode("span", _hoisted_38, _toDisplayString(channel), 1), _createElementVNode("span", _hoisted_39, _toDisplayString(count.toLocaleString()), 1), _createElementVNode("span", _hoisted_40, _toDisplayString($options.getPercentage(count, $data.indexInfo.totalFiles)) + "%", 1)]);
  }), 128))])]))])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(_component_font_awesome_icon, {
    icon: "file-alt"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.fileStatusDistribution')), 1)]), _createElementVNode("div", _hoisted_43, [Object.keys($data.indexInfo.typeStats || {}).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_font_awesome_icon, {
    icon: "inbox"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.noData')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_Doughnut, {
    data: $options.typeChartData,
    options: $options.chartOptions
  }, null, 8, ["data", "options"]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(Object.keys($data.indexInfo.typeStats).length), 1), _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('sysStatus.statusTypes')), 1)])]), _createElementVNode("div", _hoisted_50, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.aggregatedTypeStats, (count, status, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: status,
      class: "legend-item"
    }, [_createElementVNode("span", {
      class: "legend-color",
      style: _normalizeStyle({
        background: $options.getTypeChartColor(index)
      })
    }, null, 4), _createElementVNode("span", _hoisted_51, _toDisplayString(status), 1), _createElementVNode("span", _hoisted_52, _toDisplayString(count.toLocaleString()), 1), _createElementVNode("span", _hoisted_53, _toDisplayString($options.getPercentage(count, $data.indexInfo.totalFiles)) + "%", 1)]);
  }), 128))])]))])])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_font_awesome_icon, {
    icon: "tools"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.systemMaintenance')), 1)]), _createElementVNode("div", _hoisted_57, [$data.isProcessing ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("span", _hoisted_60, _toDisplayString($options.phaseDescription), 1), _createElementVNode("span", _hoisted_61, _toDisplayString(Math.round($data.processingProgress.percentage)) + "%", 1)]), _createVNode(_component_el_progress, {
    percentage: $data.processingProgress.percentage,
    "stroke-width": 12,
    "show-text": false,
    class: "progress-bar"
  }, null, 8, ["percentage"]), _createElementVNode("div", _hoisted_62, [$data.processingProgress.current > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_63, [_createVNode(_component_font_awesome_icon, {
    icon: "file-alt"
  }), _createTextVNode(" " + _toDisplayString($data.processingProgress.current.toLocaleString()) + " ", 1), $data.processingProgress.total > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(" / " + _toDisplayString($data.processingProgress.total.toLocaleString()), 1)], 64)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.$t('sysStatus.records')), 1)])) : _createCommentVNode("", true), $options.estimatedTimeRemaining ? (_openBlock(), _createElementBlock("span", _hoisted_64, [_createVNode(_component_font_awesome_icon, {
    icon: "clock"
  }), _createTextVNode(" " + _toDisplayString($options.estimatedTimeRemaining), 1)])) : _createCommentVNode("", true)]), $data.processingProgress.message ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString($data.processingProgress.message), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    type: "danger",
    plain: "",
    size: "small",
    onClick: $options.cancelOperation,
    class: "cancel-btn"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "times"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('sysStatus.cancelOperation')), 1)]),
    _: 1
  }, 8, ["onClick"])])) : $data.processingError ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createVNode(_component_font_awesome_icon, {
    icon: "exclamation-triangle"
  })]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, _toDisplayString($data.processingError.message), 1), $data.processingError.suggestion ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString($data.processingError.suggestion), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_71, [$data.processingError.recoverable ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    size: "small",
    onClick: $options.retryOperation
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "redo"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('sysStatus.retry')), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    type: "default",
    size: "small",
    onClick: $options.dismissError
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysStatus.close')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_72, [_createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysStatus.rebuildTooltip'),
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      loading: $data.rebuilding,
      disabled: $data.isProcessing,
      onClick: $options.rebuildIndex,
      class: "action-btn rebuild-btn"
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "sync-alt"
      }), _createTextVNode(" " + _toDisplayString($data.rebuilding ? _ctx.$t('sysStatus.rebuilding') : _ctx.$t('sysStatus.rebuildIndex')), 1)]),
      _: 1
    }, 8, ["loading", "disabled", "onClick"])]),
    _: 1
  }, 8, ["content"]), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysStatus.backupTooltip'),
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "success",
      loading: $data.backing,
      disabled: $data.isProcessing,
      onClick: $options.backupData,
      class: "action-btn backup-btn"
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "download"
      }), _createTextVNode(" " + _toDisplayString($data.backing ? _ctx.$t('sysStatus.backingUp') : _ctx.$t('sysStatus.backupData')), 1)]),
      _: 1
    }, 8, ["loading", "disabled", "onClick"])]),
    _: 1
  }, 8, ["content"]), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysStatus.restoreTooltip'),
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_73, [_createElementVNode("input", {
      type: "file",
      ref: "fileInput",
      accept: ".json",
      onChange: _cache[5] || (_cache[5] = (...args) => $options.handleFileSelect && $options.handleFileSelect(...args)),
      style: {
        "display": "none"
      }
    }, null, 544), _createVNode(_component_el_button, {
      type: "warning",
      loading: $data.restoring,
      disabled: $data.isProcessing,
      onClick: $options.selectRestoreFile,
      class: "action-btn restore-btn"
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "upload"
      }), _createTextVNode(" " + _toDisplayString($data.restoring ? _ctx.$t('sysStatus.restoring') : _ctx.$t('sysStatus.restoreData')), 1)]),
      _: 1
    }, 8, ["loading", "disabled", "onClick"])])]),
    _: 1
  }, 8, ["content"])]))])])]), $data.indexInfo.newestFile || $data.indexInfo.oldestFile ? (_openBlock(), _createElementBlock("div", _hoisted_74, [$data.indexInfo.newestFile ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "file-info-card info-card-newest",
    onClick: _cache[8] || (_cache[8] = $event => $options.openFileInNewTab($data.indexInfo.newestFile))
  }, [$options.isImageFile($data.indexInfo.newestFile) && !$data.loadErrors['newest'] ? (_openBlock(), _createBlock(_component_el_image, {
    key: 0,
    src: '/file/' + $data.indexInfo.newestFile.id + '?from=admin',
    fit: "cover",
    class: "card-bg-media",
    onError: _cache[6] || (_cache[6] = $event => $options.handleImageError('newest'))
  }, null, 8, ["src"])) : $options.isVideoFile($data.indexInfo.newestFile) && !$data.loadErrors['newest'] ? (_openBlock(), _createElementBlock("video", {
    key: 1,
    src: '/file/' + $data.indexInfo.newestFile.id + '?from=admin',
    class: "card-bg-media",
    muted: "",
    loop: "",
    autoplay: "",
    onError: _cache[7] || (_cache[7] = $event => $options.handleImageError('newest'))
  }, null, 40, _hoisted_75)) : (_openBlock(), _createElementBlock("div", _hoisted_76, [_createVNode(_component_font_awesome_icon, {
    icon: "file-alt",
    class: "fallback-icon"
  })])), _createElementVNode("div", _hoisted_77, [_createVNode(_component_font_awesome_icon, {
    icon: "arrow-up"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.latestUpload')), 1)]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, _toDisplayString($data.indexInfo.newestFile.metadata?.FileName || $data.indexInfo.newestFile.id), 1), _createElementVNode("div", _hoisted_80, _toDisplayString($options.formatTime($data.indexInfo.newestFile.metadata?.TimeStamp)), 1)])])) : _createCommentVNode("", true), $data.indexInfo.oldestFile ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "file-info-card info-card-oldest",
    onClick: _cache[11] || (_cache[11] = $event => $options.openFileInNewTab($data.indexInfo.oldestFile))
  }, [$options.isImageFile($data.indexInfo.oldestFile) && !$data.loadErrors['oldest'] ? (_openBlock(), _createBlock(_component_el_image, {
    key: 0,
    src: '/file/' + $data.indexInfo.oldestFile.id + '?from=admin',
    fit: "cover",
    class: "card-bg-media",
    onError: _cache[9] || (_cache[9] = $event => $options.handleImageError('oldest'))
  }, null, 8, ["src"])) : $options.isVideoFile($data.indexInfo.oldestFile) && !$data.loadErrors['oldest'] ? (_openBlock(), _createElementBlock("video", {
    key: 1,
    src: '/file/' + $data.indexInfo.oldestFile.id + '?from=admin',
    class: "card-bg-media",
    muted: "",
    loop: "",
    autoplay: "",
    onError: _cache[10] || (_cache[10] = $event => $options.handleImageError('oldest'))
  }, null, 40, _hoisted_81)) : (_openBlock(), _createElementBlock("div", _hoisted_82, [_createVNode(_component_font_awesome_icon, {
    icon: "file-alt",
    class: "fallback-icon"
  })])), _createElementVNode("div", _hoisted_83, [_createVNode(_component_font_awesome_icon, {
    icon: "arrow-down"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysStatus.earliestUpload')), 1)]), _createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, _toDisplayString($data.indexInfo.oldestFile.metadata?.FileName || $data.indexInfo.oldestFile.id), 1), _createElementVNode("div", _hoisted_86, _toDisplayString($options.formatTime($data.indexInfo.oldestFile.metadata?.TimeStamp)), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]]);
}